// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"dynamic-multiple-offers-switch-frequency-new-benefits-lock_modalContent__gIe4_"};